import { render, staticRenderFns } from "./patient_documents.vue?vue&type=template&id=058b89c7&"
import script from "./patient_documents.vue?vue&type=script&lang=js&"
export * from "./patient_documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports